import { motion, Variants } from "framer-motion";
import { useRef } from "react";
import styled from "styled-components";
import { useMouseOver } from "../../lib/hooks/useMouseOver";
import { Box } from "../Box";

interface TimelinePaginationItemProps {
  state: number;
  totalLength: number;
  itemId: number;
  onClick: () => any;
}

const stateMapper = (v: number) => {
  // const x = i - activeIndex;

  switch (v) {
    case 0:
      return "prim";
    case -1:
      return "sec";
    case 1:
      return "sec";
    case -2:
      return "tert";
    case 2:
      return "tert";
    case -3:
      return "quat";
    case 3:
      return "quat";
    default:
      return "default";
  }
};

const Padder = styled(motion(Box))`
  position: relative;
  cursor: pointer;
  width: 20px;
`;

const Line = styled(motion(Box))`
  background-color: ${({ theme }) => theme.colors.hotPink};
  height: 2px;
`;

const ActiveInd = styled(motion(Box))`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
`;

const Bubble = styled(motion.div)`
  position: absolute;
  top: 50%;
  left: calc(100% + 8px);
`;

const Round = styled(motion.div)`
  position: relative;
  transform: translateY(-50%);
  height: 56px;
  width: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.hotPink};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  padding-top: 4px;
`;

const Arrow = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  left: -6px;
  top: 50%;
  transform: translateY(-50%);

  border-top: 9px solid transparent;
  border-bottom: 9px solid transparent;

  border-right: 9px solid ${({ theme }) => theme.colors.hotPink}; ;
`;

const lineVariants: Variants = {
  prim: { scaleX: 1.6 },
  sec: { scaleX: 1.4 },
  tert: { scaleX: 1.2 },
  quat: { scaleX: 1.0 },
};

const activeVariants: Variants = {
  prim: { scale: 1, opacity: 1 },
  sec: { scale: 0, opacity: 0 },
  tert: { scale: 0, opacity: 0 },
  quat: { scale: 0, opacity: 0 },
  default: { scale: 0, opacity: 0 },
};

const lineHoverVar: Variants = {
  hover: { scaleX: 1.2 },
};

export const TimelinePaginationItem: React.FC<TimelinePaginationItemProps> = ({
  state,
  totalLength,
  itemId,
  children,
  onClick,
}) => {
  const opacity = (v: number) => {
    const abs = Math.abs(v);

    return Math.max((totalLength - abs) / totalLength, 0.3);
  };

  const ref = useRef(null);
  const isHovered = useMouseOver(ref);

  return (
    <Padder
      py={"6px"}
      px={"4px"}
      whileHover={"hover"}
      ref={ref}
      onClick={onClick}
    >
      <motion.div variants={lineHoverVar}>
        <Line
          variants={lineVariants}
          animate={stateMapper(state)}
          opacity={opacity(state)}
        >
          <ActiveInd variants={activeVariants} />
        </Line>
      </motion.div>
      {isHovered && (
        <Bubble>
          <Round>
            <Arrow />
            {children}
          </Round>
        </Bubble>
      )}
    </Padder>
  );
};
